enum Steps {
  UPLOAD,
  MATCH_FIELDS,
  FINALIZE,
}

export default Steps;
